import { render, staticRenderFns } from "./AdminTaskTax.vue?vue&type=template&id=ec524f06"
import script from "./AdminTaskTax.vue?vue&type=script&lang=js"
export * from "./AdminTaskTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports